"use client";
import { useEffect } from "react";

export function MobileFilterBehavior(){
  useEffect(()=>{
    const close=()=>{document.querySelector(".filter-sidebar")?.classList.remove("filters-open");document.body.classList.remove("filters-lock")};
    const click=(event:MouseEvent)=>{const target=event.target as HTMLElement;if(!target.closest(".filter-title"))return;if(!matchMedia("(max-width: 760px)").matches)return;const sidebar=target.closest(".filter-sidebar");if(!sidebar)return;const open=sidebar.classList.toggle("filters-open");document.body.classList.toggle("filters-lock",open)};
    const key=(event:KeyboardEvent)=>{if(event.key==="Escape")close()};
    document.addEventListener("click",click);document.addEventListener("keydown",key);window.addEventListener("popstate",close);
    return()=>{document.removeEventListener("click",click);document.removeEventListener("keydown",key);window.removeEventListener("popstate",close);document.body.classList.remove("filters-lock")};
  },[]);
  return null;
}
